import React from 'react';
import PropTypes from 'prop-types';
import { FAIcon } from './fa-icon/component.js';
/** renders a back button
 * if action===true then use router to go back
 * else call the action
 */

var BackButton = function BackButton(_ref) {
  var action = _ref.action,
      router = _ref.router;

  function onClick(e) {
    e.preventDefault();

    if (action === true) {
      if (router && typeof router.goBack === 'function') {
        router.goBack();
      } else {
        throw new Error('must pass router as a prop in order to use default back action');
      }
    } else if (typeof action === 'function') {
      action(e);
    }
  }

  return /*#__PURE__*/React.createElement("a", {
    role: "button",
    className: "back-button",
    onClick: onClick,
    "aria-label": "back",
    "data-back-arrow": true
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "arrow-left"
  }));
};

BackButton.displayName = "BackButton";
BackButton.propTypes = {
  action: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  router: PropTypes.shape({
    goBack: PropTypes.func
  })
};
export { BackButton };